import { useDialogStateContext } from '../../DialogContextProvider';

function useOpenedDialog() {
    const state = useDialogStateContext();
    const open = state?.actionDialogs?.openedDialog;

    return open;
}

export default useOpenedDialog;